'use es6';

import { email } from 'ContentUtils/constants/Categories';
import ImmutableModel from 'DesignData/models/ImmutableModel';
import { LAYOUT, TEMPLATE, CUSTOM_WIDGET, GLOBAL_WIDGET } from 'DesignData/enums/DesignAssetTypes';
import { LAYOUT as COS_INDEX_OBJECT_TYPE_LAYOUT, EXTENSION_RESOURCE, CUSTOM_WIDGET as COS_INDEX_OBJECT_TYPE_CUSTOM_WIDGET, WIDGET, CONTENT, BLOG, SITE_SETTINGS, DOMAIN, GLOBAL_CONTENT, QUOTE_TEMPLATE } from 'DesignData/enums/CosIndexObjectTypes';
export default class CosIndexConnection extends ImmutableModel {
  constructor(props) {
    return super(props);
  }

  get isLayout() {
    return this.type === COS_INDEX_OBJECT_TYPE_LAYOUT;
  }

  get isCodedFile() {
    return this.type === EXTENSION_RESOURCE;
  }

  get isCustomWidget() {
    return this.type === COS_INDEX_OBJECT_TYPE_CUSTOM_WIDGET;
  }

  get isGlobalWidget() {
    return this.type === WIDGET;
  }

  get isContent() {
    return this.type === CONTENT;
  }

  get isBlog() {
    return this.type === BLOG;
  }

  get isEmail() {
    return this.isContent && this.model.categoryId === email.id;
  }

  get isPublishedPage() {
    return this.isContent && !this.isEmail && this.model.isPublished;
  }

  get isDraftPage() {
    return this.isContent && !this.isEmail && !this.model.isPublished;
  }

  get isSentEmail() {
    return this.isEmail && this.model.isPublished;
  }

  get isDraftEmail() {
    return this.isEmail && !this.model.isPublished;
  }

  get isSiteSettings() {
    return this.type === SITE_SETTINGS;
  }

  get isDomainSettings() {
    return this.type === DOMAIN;
  }

  get isGlobalContent() {
    return this.type === GLOBAL_CONTENT;
  }

  get isSalesQuoteTemplate() {
    return this.type === QUOTE_TEMPLATE;
  }

  getAssetType() {
    if (this.isLayout) return LAYOUT;
    if (this.isCodedFile) return TEMPLATE;
    if (this.isCustomWidget) return CUSTOM_WIDGET;
    if (this.isGlobalWidget) return GLOBAL_WIDGET;
    return null;
  }

}